// extracted by mini-css-extract-plugin
export default {"container":"RerollComponent_container__xnxeH","premiumIcon":"RerollComponent_premiumIcon__VTvxb"};